<template>
  <div>
    <div class="my-14" v-if="period.status === 'created'">
      <div class="subtitle-1">Biểu phí trong kỳ chưa được tổng kết.</div>
      <div v-if="canSummaryPeriod" class="subtitle-1">
        Vui lòng thực hiện thao tác [Tiến hành tổng kết].
      </div>
      <v-btn v-if="canSummaryPeriod" class="ml-6 mt-6" depressed dark color="#0D47A1" @click="onSummary">
        <v-icon>mdi-wallet-plus</v-icon> &nbsp; TIẾN HÀNH TỔNG KẾT
      </v-btn>
    </div>
    <div class="my-14" v-if="period.status === 'running'">
      <SummaryLoading />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import SummaryLoading from './SummaryLoading.vue'
export default {
  components: {
    SummaryLoading
  },
  computed: {
    ...mapGetters({
      period: 'salaryPeriod/period',
      user: 'auth/user'
    }),
    canSummaryPeriod() {
      return true
    }
  },
  methods: {
    ...mapActions({
      updatePeriod: 'salaryPeriod/updatePeriod'
    }),
    onSummary() {
      this.$dialog.confirm({
        title: 'Xác nhận tổng kết kỳ lương?',
        text:
          'Hệ thống sẽ thực hiện tổng kết kỳ lương này.<br/> Thao tác này có thể sẽ mất nhiều thời gian, vui lòng đợi.',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            await this.updatePeriod({
              id: this.period.id,
              data: { status: 'running', type: 'all', generatedBy: this.user.id }
            })
            this.$alert.success('Đã tổng kết thành công!')
          } catch (e) {
            let msg = {
              title: 'Lỗi thao tác',
              description: 'Hệ thống đang thực hiện tổng kết. Vui lòng chờ.'
            }
            if (e === 'Connection fail') {
              msg = {
                title: 'Lỗi kết nối',
                description: 'Không thể thực hiện tổng kết. Vui lòng thử lại.'
              }
            }
            this.$alert.error({ title: msg.title, description: msg.description })
          }
        }
      })
    }
  }
}
</script>
